import { cn } from "../../../lib/utils.js";
import { DECORATIVE_WAVEFORM_HEIGHTS } from "../media-clock.js";

function WaveformBars({
  className,
  barHeights,
}: {
  className: string;
  barHeights: readonly number[];
}): React.JSX.Element {
  return (
    <div className={cn("flex h-7 w-full items-center justify-between gap-px", className)}>
      {barHeights.map((height, index) => (
        <span
          key={index}
          className="w-[2px] shrink-0 rounded-full sm:w-[2.5px]"
          style={{ height: `${Math.round(height * 100)}%` }}
        />
      ))}
    </div>
  );
}

export function DecorativeWaveform({
  progress,
  isRtl = false,
  className,
  barHeights,
}: {
  progress: number;
  isRtl?: boolean;
  className?: string;
  barHeights?: readonly number[];
}): React.JSX.Element {
  const heights = barHeights ?? DECORATIVE_WAVEFORM_HEIGHTS;
  const filled = Math.min(1, Math.max(0, progress));
  const unfilled = Math.round((1 - filled) * 1000) / 10;
  const clipPath = isRtl
    ? `inset(0 0 0 ${unfilled}%)`
    : `inset(0 ${unfilled}% 0 0)`;

  return (
    <div className={cn("relative h-7 w-full", className)} aria-hidden="true">
      <WaveformBars barHeights={heights} className="text-ink/25 [&>span]:bg-current" />
      <div className="absolute inset-0" style={{ clipPath }}>
        <WaveformBars barHeights={heights} className="text-accent [&>span]:bg-current" />
      </div>
    </div>
  );
}
